module.exports = __webpack_public_path__ + "img/i.527ddf30.svg";